import * as ScrollLock from 'scroll-lock';
import {getSizedImageUrl} from '@shopify/theme-images';

window.theme = window.theme || {};
window.theme.ScrollLock = ScrollLock;
window.theme.getSizedImageUrl = getSizedImageUrl;
